import { Grid, Paper, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { IFilteringViewModel } from "../../_common/interface/table";
import { CommonTable } from "../../_components/table/common.table";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formService } from "../../_services/form.service";
import { PrimaryButton } from "../../_components/button/primary.button";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { useNavigate, useParams } from "react-router-dom";
import { PageHeader } from "../../_components/header/page.header";


export function UserProfileInsuranceList(params: {}) {

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const { userId, type } = useParams<{ userId: string, type: string }>();

    const formTemplateTypeId = type === "IRDS" ? FormTemplateTypeEnum.IRDS : FormTemplateTypeEnum.BRDS;

    const [filter, setFilter] = useState<IFilteringViewModel>({
        name: '',
        userId: (userId || "")
    });

    let navigate = useNavigate();

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'id',
                header: 'Id',
            },
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'status',
                header: 'Form Status',
            },
            {
                accessorKey: 'formTypeName',
                header: 'Form Type',
            },
            {
                accessorKey: 'userName',
                header: 'User Name',
            }
        ],
        [],
    );

    useEffect(() => {
        fetchData();
    }, [filter, type]);

    function fetchData() {

        return formService.getAll({ ...filter, formTemplateTypeId: formTemplateTypeId })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    function CreateForm(type: FormTemplateTypeEnum) {

        return formService.createByType(type, userId)
            .then(
                data => {
                    navigate("../Forms/" + data)
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>


            <PageHeader
                pageName={formTemplateTypeId === FormTemplateTypeEnum.BRDS ? "BRDS" : "IRDS"}
                actionType="create"
                buttonName={formTemplateTypeId === FormTemplateTypeEnum.BRDS ? "New Application" : "New Application"}
                onClick={() => { CreateForm(formTemplateTypeId) }}
            />

            <Paper>
                <CommonTable
                    columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                    isLoading={isLoading}
                    onEdit={(id) => { navigate(`../Forms/${id}`) }}
                />
            </Paper>
        </>
    );
}